import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";

@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }

    const [day, month, year] = value.split('.', 3);
    return {
      day: parseInt(day, 10),
      month: parseInt(month, 10),
      year: parseInt(year, 10)
    };
  }

  format(date: NgbDateStruct): string {
    if (!date) {
      return null;
    }
    return `${date.day}.${date.month}.${date.year}`;
  }
}
